import * as React from "react";

export default function Toast({ text, intent }) {

    const intentStyle = {
        primary: { padding: "0.75rem 1.5rem", position: "fixed", bottom: "1rem", background: "#ff4989", color: "white", fontSize: "var(--font-size-3)", boxShadow: "0px 3px 10px -5px #00000080", borderRadius: "4px", left: "50%", transform: "translate(-50%, 0%)" },
        success: { padding: "0.75rem 1.5rem", position: "fixed", bottom: "1rem", background: "#00D8D5", fontSize: "var(--font-size-3)", boxShadow: "0px 3px 10px -5px #00000080", borderRadius: "4px", left: "50%", transform: "translate(-50%, 0%)" },
        error: { padding: "0.75rem 1.5rem", position: "fixed", bottom: "1rem", border: "1px solid", background: "red", fontSize: "var(--font-size-3)", boxShadow: "0px 3px 10px -5px #00000080", borderRadius: "4px", left: "50%", transform: "translate(-50%, 0%)" },
        default: { padding: "0.75rem 1.5rem", position: "fixed", bottom: "1rem", border: "1px solid", fontSize: "var(--font-size-3)", boxShadow: "0px 3px 10px -5px #00000080", borderRadius: "4px", left: "50%", transform: "translate(-50%, 0%)" }
    };

    const style = intent ? intentStyle[intent] : intentStyle.default;

    return <div><div className="toast" style={style}>{text}</div>
        <style jsx>
            {`
        .toast {
            animation-name: toastAnimation;
            animation-duration: 4s;
            animation-fill-mode: forwards;
            animation-timing-function: ease-in-out;
          }
          `}
        </style></div>;

}
